import { lazy, Suspense, FunctionComponent, useEffect } from 'react';

/**
 * Components
 */
import { IndexPageSkeleton } from './Skeleton';

const PageSections = lazy(() => import('@/components/PageSections'));

/**
 * Hooks
 */
import useTracking from '@/hooks/useTracking';
import usePredictionFilters from '@/hooks/usePredictionFilters';

const IndexPageScreen: FunctionComponent = () => {
  const { trackInitialization } = useTracking();
  const { predictionFilters } = usePredictionFilters();

  useEffect(() => {
    trackInitialization();
  }, []);

  /**
   * Render
   */
  if (predictionFilters) {
    return (
      <Suspense fallback={<IndexPageSkeleton />}>
        <PageSections />
      </Suspense>
    );
  }

  return null;
};

export default IndexPageScreen;
